import React from 'react';
import { motion } from 'framer-motion';
import { SectionWrapper } from './SectionWrapper';
const forWho = ['Padres de adolescentes (12-18 años) que se sienten ignorados o rechazados.', 'Madres que lloran en silencio porque no reconocen al hijo que antes las abrazaba.', 'Familias donde las discusiones por reglas o estudios terminan siempre en gritos.', 'Padres que quieren poner límites claros sin destruir la relación emocional.'];
const notForWho = ['Padres que buscan fórmulas para una obediencia ciega y militar.', 'Familias que no están dispuestas a cambiar su propia forma de reaccionar.', 'Quienes buscan una solución mágica sin aplicar los ejercicios de comunicación.'];
export function AudienceSection() {
  return <SectionWrapper data-id="element-1">
      <div className="grid md:grid-cols-2 gap-12" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-3">
          <h3 className="text-2xl font-heading font-bold text-primary mb-6 border-b border-subtle pb-4" data-id="element-4">
            Esto ES para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-5">
            {forWho.map((item, i) => <li key={i} className="flex items-start" data-id="element-6">
                <span className="text-amber mr-3 mt-1 text-lg leading-none" data-id="element-7">
                  •
                </span>
                <span className="text-secondary font-body" data-id="element-8">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-9">
          <h3 className="text-2xl font-heading font-bold text-primary mb-6 border-b border-subtle pb-4 opacity-60" data-id="element-10">
            Esto NO es para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-11">
            {notForWho.map((item, i) => <li key={i} className="flex items-start opacity-70" data-id="element-12">
                <span className="text-primary mr-3 mt-1 text-lg leading-none" data-id="element-13">
                  -
                </span>
                <span className="text-secondary font-body" data-id="element-14">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </SectionWrapper>;
}